import { createFeatureSelector, createSelector } from '@ngrx/store';

import { merchandisePricesFeatureKey, State } from '../models/state';

export const selectMerchandisePricesState = createFeatureSelector<State>(
  merchandisePricesFeatureKey,
);

export const selectProductPriceDiscount = createSelector(
  selectMerchandisePricesState,
  (state: State, productId: number) => state[productId],
);
